import { render, staticRenderFns } from "./uploadImageBtn.vue?vue&type=template&id=1c408474&scoped=true"
import script from "./uploadImageBtn.vue?vue&type=script&lang=js"
export * from "./uploadImageBtn.vue?vue&type=script&lang=js"
import style0 from "./uploadImageBtn.vue?vue&type=style&index=0&id=1c408474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c408474",
  null
  
)

export default component.exports